import { translateToHTML } from '../../../react/features/base/i18n/functions';
import i18next from '../../../react/features/base/i18n/i18next';
import { copyText } from '../../../react/features/base/util/copyText.web';
import { getDialInNumbers } from '../../../react/features/invite/_utils';
import { getDialInfoPageURL } from '../../../react/features/invite/functions';
import { showNotification } from '../../../react/features/notifications/actions';
import { NOTIFICATION_TIMEOUT_TYPE } from '../../../react/features/notifications/constants';
// @ts-ignore
import PHONE_NUMBER_LIST from '../../dialin/phoneNumberList.json';
import { sendStatsToKibana } from '../analytics/kibana/actions';
import { KIBANA_MESSAGES } from '../analytics/kibana/constants';
import { getPhoneNumberByLangWildix } from '../invite/functions';
import { BUTTONS } from './constants';
export function showNoAudioNotify() {
    return (dispatch, getState) => {
        const state = getState();
        const { room = '' } = state['features/base/conference'];
        const { roomPin, dialInNumbersUrl, hosts } = state['features/base/config'];
        const t = i18next.t.bind(i18next);
        const mucURL = hosts?.muc;
        const dialInURL = getDialInfoPageURL(state);
        getDialInNumbers(dialInNumbersUrl, room, mucURL).then(({ result }) => {
            showNotificationNoAudio(dispatch, t, {
                dialInURL,
                phoneNumber: getPhoneNumberByLangWildix(result),
                roomPin
            });
        })
            .catch(() => {
            showNotificationNoAudio(dispatch, t, {
                dialInURL,
                phoneNumber: getPhoneNumberByLangWildix(PHONE_NUMBER_LIST),
                roomPin
            });
        });
    };
}
function showNotificationNoAudio(dispatch, t, props) {
    const { phoneNumber, roomPin, dialInURL } = props;
    dispatch(showNotification({
        titleKey: 'notification.noAudioTitle',
        description: translateToHTML(t, 'notification.noAudioDescription', {
            phoneNumber: `<div>${t('info.dialInNumber')} ${phoneNumber}</div>`,
            roomPin: `<div>${t('info.dialInConferenceID')} ${roomPin}</div>`
        }),
        customActionNameKey: ['', BUTTONS.MORE_NUMBERS],
        customActionType: ['copy-button-no-audio', 'link'],
        customActionHandler: [() => {
                copyText(phoneNumber);
                dispatch(sendStatsToKibana([{}], KIBANA_MESSAGES.NoAudioCopyText));
            },
            () => {
                window.open(dialInURL, '_blank', 'noopener');
                dispatch(sendStatsToKibana([{}], KIBANA_MESSAGES.NoAudioMoreNumbers));
            }
        ]
    }, NOTIFICATION_TIMEOUT_TYPE.STICKY));
    dispatch(sendStatsToKibana([{
            roomPin,
            phoneNumber
        }], KIBANA_MESSAGES.NoAudioDetectProblem));
}
